import { render } from "./UserAccountMenu.vue?vue&type=template&id=03285b5d&ts=true"
import script from "./UserAccountMenu.vue?vue&type=script&lang=ts"
export * from "./UserAccountMenu.vue?vue&type=script&lang=ts"

import exportComponent from "/home/gitlab-deployer/builds/Bp7u02vYG/0/erp/admissibles-front/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__